export enum EmissionLine {
    KAlpha,
    KBeta,
    LAlpha,
    LBeta
}
